/*!jslint this */
jQuery(function ($) {
  "use strict";

  const $window = $(window);
  const $document = $(document);

  let resizeRaf = null;

  /**
   * Set CSS app height variable
   */
  function setAppHeight() {
    document.documentElement.style.setProperty(
      "--app-height",
      window.innerHeight + "px",
    );
  }

  /**
   * Optimized resize handler
   */
  function onResize() {
    if (resizeRaf) {
      cancelAnimationFrame(resizeRaf);
    }

    resizeRaf = requestAnimationFrame(setAppHeight);
  }

  // Initial set (delay allows mobile UI to settle)
  setTimeout(setAppHeight, 100);

  // Resize listener
  $window.on("resize", onResize);

  function setHeaderHeight() {
    $("html").css("--header-height", $(".site-header").outerHeight() + "px");
  }
  setHeaderHeight();


});
